import { computed, type Ref } from "vue";
import { useQuery } from "@tanstack/vue-query";
import ContactService from "@/services/contact/contact";
import type { HubSpotListsParams } from "@/dtos/HubSpot.dto";

export const useHubSpotContactLists = (params: Ref<HubSpotListsParams>) => {
  return useQuery({
    queryKey: ["hubspot-lists", params],
    queryFn: async () => {
      const response = await ContactService.getHubSpotContactLists(params.value);
      return response.data.data;
    },
    enabled: computed(() => !!params.value?.organizationId),
  });
};
